function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import { Controller } from 'stimulus';
import { saveUserToken } from '../store/actions'; // Load and save the current user from API with iframe
//
// HTML Snippet:
//
// <div class="d-none" data-controller="user" />

function postToken(token) {
  var event = new CustomEvent('user-token', {
    detail: {
      token: token
    }
  });
  window.dispatchEvent(event);
}

var _default =
/*#__PURE__*/
function (_Controller) {
  _inherits(_default, _Controller);

  function _default() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, _default);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(_default)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.jcTokenReciver = function (event) {
      if (event.type === 'message' && event.origin === _this.application.api.url) {
        _this.setToken(event.data.token);
      }
    };

    return _this;
  }

  _createClass(_default, [{
    key: "connect",
    value: function connect() {
      // Safari dose not support iframe auth
      if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
        this.createIframe();
      }

      window.addEventListener('message', this.jcTokenReciver, false);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      window.removeEventListener('message', this.jcTokenReciver, false);
    }
  }, {
    key: "createIframe",
    value: function createIframe() {
      var element = document.createElement('iframe');
      element.src = "".concat(this.application.api.url, "/user?api_key=").concat(this.application.api.key);
      element.height = '0';
      this.element.appendChild(element);
    }
  }, {
    key: "setToken",
    value: function setToken(token) {
      this.application.store.dispatch(saveUserToken(token));
      postToken(token);
      localStorage.setItem('japan-concierge-api-key', this.application.api.key);
      localStorage.setItem('japan-concierge-api-url', this.application.api.url);
      this.element.parentNode.removeChild(this.element);
    }
  }]);

  return _default;
}(Controller);

export { _default as default };